<label *ngIf="to.header" class="form-control-label">{{ to.header }}</label>
<div class="form-well">
    <app-table-light
        [data]="model['' + key]"
        (onRowChanged)="onRowChanged($event)"
        [showFooter]="to.showFooter"
    >
        <app-table-light-column
            *ngFor="let column of to.columns"
            (onChange)="onColumnChanged($event, column)"
            [editable]="column.editable"
            [header]="column.header"
            [options]="column.options"
            [totalInFooter]="column.totalInFooter"
            [type]="column.type"
            [value]="column.value"
            [visible]="column.visible"
            [width]="column.width"
            [numberPipe]="column.numberPipe"
            [frozen]="column.frozen"
        >
        </app-table-light-column>
    </app-table-light>
</div>
<div *ngIf="to && to.note" class="col-12">
    <sub [innerHTML]="to.note"></sub>
</div>
<div class="clearfix"></div>
